import { FC } from 'react';
import { ButtonLink } from '@domgen/base-design-system-2.0/atoms/ButtonLink';
import { Phone } from '../../../assets/icons/Phone';
import { BannerSection, BenefitsSection, CtaSection, HeroSection, PromoSection } from '../sections';
import { LandingVariantProps } from './types';

/**
 * LP1 — call-centre only: the phone CTA with no online registration link. Also
 * rendered whenever the visitor's locale has no online link configured,
 * regardless of the experience the payload selected.
 */
export const PhoneOnly: FC<LandingVariantProps> = ({ data, copy, onCtaClick }) => (
  <div className="grid grid-cols-12">
    <BannerSection text={copy.banner} />
    <HeroSection number={data.heroNumber} copy={copy.heroCopy} />
    <PromoSection subCopy1={copy.heroSubCopy1} subCopy2={copy.heroSubCopy2} />
    <CtaSection title={copy.registration}>
      <div className="w-full md:w-fit">
        <ButtonLink
          leftIcon={Phone()}
          href={`${data.ctaPhoneLink}`}
          variant="primary"
          id="phone-cta"
          onClick={() => onCtaClick('phone', data.ctaPhoneLink)}
        >
          {copy.ctaPhoneText}
        </ButtonLink>
      </div>
      {/* Beko-live parity: keep centred text but cap at 850px, centred as a
          block (see .beko-phone-subcopy in styles.css). */}
      <p className="text-body beko-phone-subcopy">{copy.phoneSubCopy}</p>
    </CtaSection>
    <BenefitsSection header={data.benefitsHeader} benefits={data.benefits} />
  </div>
);
